import { CheckFill, PlayButtonStroke } from '../../../assets/icons';
import { CardState } from '../../types';
import {
  StyledDescription,
  StyledImage,
  StyledImageWrapper,
  StyledLabel,
  StyledTagContainer,
  StyledTitle,
  StyledVideoPlayButton,
  TextWrapper,
  Wrapper,
} from './styles';

type ContentCardProps = {
  label: string;
  description: string;
  link: string;
  image: string;
  imageAlt: string;
  title: string;
  state: CardState;
  isVideo?: boolean;
};

const ContentCard: React.FC<ContentCardProps> = ({
  label,
  description,
  link,
  image,
  imageAlt,
  title,
  state,
  isVideo,
}) => {
  return (
    <Wrapper to={link}>
      {state === 'complete' && (
        <StyledTagContainer>
          <CheckFill color="white" fontSize="10px" />
        </StyledTagContainer>
      )}
      <StyledImageWrapper state={state}>
        {isVideo && (
          <StyledVideoPlayButton>
            <PlayButtonStroke color="white" />
          </StyledVideoPlayButton>
        )}
        <StyledImage src={image} alt={imageAlt} />
      </StyledImageWrapper>
      <TextWrapper>
        <StyledLabel>{label}</StyledLabel>
        <StyledTitle>{title}</StyledTitle>
        <StyledDescription>{description}</StyledDescription>
      </TextWrapper>
    </Wrapper>
  );
};
export default ContentCard;
